import { Observable } from 'rxjs';
import { ContractAgreement } from '../models/contract-agreement.model';

/**
 * Stable domain contract for contract-agreement read operations.
 * Implemented by AdessoContractAgreementApiAdapter against the adesso-connector-api.
 */
export abstract class AgreementApiPort {
  abstract getContractAgreements(): Observable<ContractAgreement[]>;
  abstract getContractAgreementById(id: string): Observable<ContractAgreement>;
}
